/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector, getLocale, useIntl, shallowEqual } from 'umi';
import { Card, Row, Col, Text, Bubble, } from 'tea-component';
import moment from 'moment';
import { showByApi as showDownloadSettings, DownloadOptions } from '@/pages/dashboard/components/DownloadOptionsAnalysisModal';
import NoData from "@/pages/dashboard/components/NoData";
import Loading from "@/pages/dashboard/components/Loadings";
import LoadingFailed from "@/pages/dashboard/components/LoadingFailed";
import SvgIcon from '@/pages/home/components/SvgIcon';
import TopTable from '@/pages/dashboard/components/TopTable';
import MiniTable from '@/pages/dashboard/components/MiniTable';
import useOptions from '@/pages/dashboard/components/SwitchChart/hooks/useOptions';
import LineChart from '@/pages/dashboard/components/Chart/components/LineChart';
import {
  configLineChartPointSymbol,
  formatExcelString,
  formatExeclNormalPercent,
  formatExeclNum,
  formatExeclSharePercent,
  formatNum,
  formatPercentNum,
  getUpAndDownStatus,
  unitConversion
} from '@/pages/dashboard/utils/utils';
import { getEchartTooltipText } from '@/pages/dashboard/components/EchartsBubble';
import UpAndDown from "@/pages/dashboard/components/UpAndDown";
import { xAxisLableFormat, xAxisHighLight } from '../Chart/_config/plug';
import { yAxisFormat } from '@/pages/dashboard/components/Chart/_config/utils';
import { DEEP_COLORS, LIGHT_COLORS } from "@/pages/dashboard/_config/constant";
import { useSelectorMap } from '../../utils/customHook';
import { d2D3D7Arr } from '../../pages/realtime/_config/constant';
import { useD2D3D7Text } from '../../pages/realtime/hooks';
import { PrimitiveType, FormatXMLElementFn } from 'intl-messageformat';
import { MessageDescriptor } from 'react-intl';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';

const timeDownLoadMap = {
  5: 'fiveMinutes'
};

interface ITopChangeCardProps {
  title: string;
  timeValue: string;
  shouldAnalysisRefresh?: boolean;
  cardTime: string;
  tableData: any[];
  header2: string;
  key2: string;
  loading: boolean;
  isError: boolean;
  time: {
    nowTime: string;
    preTime: string;
  };
  lastTime: string;
  dataList: any[];
  isKeyCounTry: boolean;
  gameCode: string;
  downLoadCheckboxNameMap: Record<string, string>;
  downLoadTitleMap: Record<string, string>;
  formatter?: string;
  topTableFormatter?: string;
  isPercent?: boolean;
}

export default function TOPChange(props: ITopChangeCardProps) {
  const {
    title,
    timeValue,
    shouldAnalysisRefresh,
    cardTime,
    tableData,
    header2,
    key2,
    loading,
    isError,
    time,
    lastTime,
    dataList,
    isKeyCounTry,
    gameCode,
    downLoadCheckboxNameMap,
    downLoadTitleMap,
    formatter,
    topTableFormatter,
    isPercent,
  } = props;
  const isChange = timeValue !== '23:59';
  const { selector } = useSelector((state: any) => ({
    selector: state?.dashboardSetting?.selector
  }), shallowEqual);
  const { nowTime, preTime } = time;
  const { getD2D3D7Text } = useD2D3D7Text();
  const [selectList, setSelectList] = useState(['Global']); //
  // 右侧图标
  const iconList = ['discount-chart', 'sheet'];
  // 控制图表和数据表格显示 
  const [isLine, setIsLine] = useState(iconList[0]);
  const sideBarRef = document.querySelector('body');
  let winWidth = sideBarRef?.clientWidth || 0;
  const [splitNum, setSplitNum] = useState(winWidth <= 1792 ? 12 : 24); // 新风格字体稍大，浏览器宽度改为1792，适配Mac 16吋及以下屏幕
  // 扩展isPercent字段用于判断是否是百分比指标，用于数据格式化和下载格式化
  const isRetention = ['d2', 'd3', 'd7'].includes(key2) || isPercent;
  const { formatMessage } = useIntl();
  const topTableRef = useRef();
  const { getSelectorText } = useSelectorMap();
  const isEN = getLocale() === 'en-US';

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    winWidth = sideBarRef?.clientWidth || 0;
    if (winWidth <= 1792) {
      setSplitNum(12);
    } else {
      setSplitNum(24);
    }
  };

  useEffect(() => {
    setSelectList(isKeyCounTry ? ['Total'] : ['Global']);
  }, [isKeyCounTry]);

  // 数据格式化函数
  const formatterValue = (value: number) => {
    if (formatter) {
      return dataFormat({ value, formatRule: formatter });
    }
    if (isRetention) {
      return formatPercentNum(value, 2);
    }
    return formatNum(value, false, true);
  };

  const getOptions = () => {
    const tableHeader = [
      {
        key: 'time',
        header: formatMessage({ id: 'realtime_analysis_Time' }),
        align: 'left',
        // width: 100,
        render: (tr: { time: string | any[]; }) => (<span>{tr.time.slice(0, 5)}</span>),
      },
      {
        key: 'name',
        header: formatMessage({ id: 'realtime_analysis_Country' }),
        align: 'left',
        render: (tr: { name: string; }) => {
          const nameTxt = (() => {
            if (['Total', 'Global'].includes(tr.name)) return formatMessage({ id: `realtime_analysis_${tr.name}` });
            return getSelectorText('country', tr.name);
          })();
          return <span>{nameTxt}</span>;
        },
      },
      {
        key: 'value',
        header: nowTime,
        align: 'right',
        render: (tr: { value: number; }) => {
          const mathtxt = formatterValue(tr?.value);
          return <span>{mathtxt}</span>;
        },
      },
      {
        key: 'contrast_value',
        header: preTime,
        align: 'right',
        render: (tr: { contrast_value: number; }) => (<span>{formatterValue(tr?.contrast_value)}</span>),
      },
      {
        key: 'change',
        header: formatMessage({ id: 'realtime_analysis_Change' }),
        align: 'right',
        render: (tr: { change: number; }) => (<UpAndDown
          data={formatPercentNum(tr?.change, 1)}
          status={getUpAndDownStatus(tr?.change)}
        />)
      },
    ];

    let options = {
      chart: [] as Array<{}>,
      table: {
        option: [] as Array<{}>,
        data: [] as Array<{}>
      }
    };
    const legend: any[] = [];

    selectList.forEach((item) => {
      legend.push({ key: 'value', name: selectList.length > 1 ? `${item} ` : `${item} ${nowTime}` });
      legend.push({ key: 'contrast_value', name: selectList.length > 1 ? item : `${item} ${preTime}` });
    });

    if (dataList === null || dataList?.length === 0) return options;
    const chartData: Array<{}> = [];
    const tableData: Array<{}> = [];
    legend.forEach((ele) => {
      const chartConfig = {
        name: ele.name,
        type: 'line',
        data: [] as Array<{}>
      };
      dataList?.forEach((row: { [x: string]: any; name: any; time: any; }) => {
        if (row.name === ele.name.trim() || [`${row.name} ${nowTime}`, `${row.name} ${preTime}`].includes(ele.name)) {
          chartConfig.data?.push({
            x: row.time,
            y: (Math.round(row[ele.key] * 10000) / 10000) || row[ele.key]
            // y: Math.round(row[ele.key]) || row[ele.key]
          });
        }
      });
      chartConfig.data?.length && chartData.push(chartConfig);
    });

    dataList?.forEach((row: { name?: any; }) => {
      if (selectList.includes(row.name)) {
        tableData.push(row);
      }
    });
    options = {
      chart: chartData,
      table: {
        option: tableHeader,
        data: tableData
      }
    };
    return options;
  };
  const options = useMemo(() => getOptions(), [dataList, selectList, selector, getLocale()]);
  const {
    chartOptions,
    handleDownload
  } = useOptions({ ...props, options: { ...options, isCompare: true } });
  let { line: lineOptions } = chartOptions || {};
  const { table: tableOptions } = chartOptions || {};
  // 折线图圆点显示逻辑
  if (lineOptions.series) {
    if (isRetention) {
      // retention相关图表的折线图
      lineOptions.series.forEach((item: { showAllSymbol: boolean; symbol: string; lineStyle: { type: string; }; symbolSize: number; }) => {
        item.showAllSymbol = true;
        item.symbol = item?.lineStyle?.type === 'solid' ? 'circle' : 'emptyCircle';
        item.symbolSize = item?.lineStyle?.type === 'solid' ? 6 : 4;
      });
    } else {
      // 在这里设置可以兼顾 对比项的折线图
      lineOptions = configLineChartPointSymbol(lineOptions); // 使用useMemo会报Rendered more hooks than during the previous render.
    }
  }

  const openDownloadSetting = async () => {
    let dOptions: any = {};
    const data = tableOptions?.data;
    const lhour: number = data?.length ? parseInt(data?.[data?.length - 1].time?.split(':')?.[0]) : 0;
    const downloadOptions: DownloadOptions = {
      formatMessage,
      options: {
        table: {
          firstName: formatMessage({ id: 'realtime_info_download_metrics_realtime_detail_data' }),
          secondName: formatMessage({ id: 'realtime_info_download_metrics_top_change_by_country' }),
        },
        timeScale: {
          show: {
            '5': !!['new', 'active', 'online'].includes(key2),
            '10': false,
            '60': true,
          },
          disabled: {
            '5': false,
            '10': false,
            '60': lhour < 1,
          },
          default: ['new', 'active', 'online'].includes(key2) ? '5' : '60',
        },
        downLoadCheckboxNameMap,
        // sort: {default:0}
      },
    };
    try {
      dOptions = await showDownloadSettings(downloadOptions);
      downLoad(dOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const downLoad = (downloadOptions: any = { timeScale: '5' }) => {
    const DEFAULT_TIME_SCALE = 5; // 接口数据的默认时间间隔
    const DEFAULT_SORT = 1;
    const timeScale: number = parseInt(downloadOptions.timeScale || 5);
    const sort: number = downloadOptions.sort || 0;
    downloadOptions?.tableSelectIndex?.forEach((selectIndex: string) => {
      const tableDown = JSON.parse(
        JSON.stringify(
          selectIndex === '0'
            ? tableOptions
            : {
              data: tableData,
              option: topTableRef.current?.getTableHeader(),
            },
        ),
      );
      tableDown.data = tableDown?.data?.filter((item: { time: string; }) => {
        if (selectIndex === '1' || timeScale === DEFAULT_TIME_SCALE) return true;
        const min: number = parseInt(item.time?.split(':')?.[1]);
        const hour: number = parseInt(item.time?.split(':')?.[0]);
        let time: number = hour * 60 + min;
        if (time === 23 * 60 + 59) {
          // 把最后一刻的时间取整
          time = 24 * 60;
        }
        return time % timeScale === 0;
      });

      tableDown?.data?.forEach((item: { name: string; change: string | { v: number; t: string; z: string; }; value: string | { v: number; t: string; z: string; }; contrast_value: string | { v: number; t: string; z: string; }; change_value: string | { v: number; t: string; z: string; }; }) => {
        item.name = ['Total', 'Global'].includes(item.name) ? formatExcelString(formatMessage({ id: `realtime_analysis_${item.name}` })) : getSelectorText('country', item.name, true);
        item.change = formatExeclSharePercent(item.change);
        item.value = isRetention ? formatExeclNormalPercent(item.value) : formatExeclNum(item.value);
        item.contrast_value = isRetention ? formatExeclNormalPercent(item.contrast_value) : formatExeclNum(item.contrast_value);
        item.change_value = formatExeclNum(item.change_value);
      });
      if (selectIndex === '0' && sort !== DEFAULT_SORT) {
        tableDown?.data?.reverse();
      }
      if (['new', 'active', 'online'].includes(key2)) {
        const content = `${selectIndex === '0' ? timeScale === 5 ? 'right_5min' : 'right_1hour' : 'left'}`;
        tableDown.downloadTitle = downLoadTitleMap?.[timeDownLoadMap?.[timeScale]]?.[isEN ? 'enName' : 'cnName'] || formatMessage({ id: `realtime_analysis_table_title_${key2}_${content}` });
      }
      if (d2D3D7Arr?.includes(key2)) {
        const content = `${selectIndex === '0' ? timeScale === 5 ? 'right_5min' : 'right_1hour' : 'left'}`;
        const d2D3D7titleObj: any = {
          d2: getD2D3D7Text('anylysizeD2ChartTitle'),
          d3: getD2D3D7Text('anylysizeD3ChartTitle'),
          d7: getD2D3D7Text('anylysizeD7ChartTitle'),
        };
        tableDown.downloadTitle = `${d2D3D7titleObj?.[key2]}${content}`;
      }
      handleDownload(tableDown);
    });
  };
  // x 轴 label 默认格式化函数，默认显示 月-日
  const defaultLabelFormatX = (value: string | number | any[] | Date | moment.Moment | moment.MomentInputObject | null | undefined) => moment(value).isValid() ? moment(value).format('MM-DD') : value.slice(0, 5);
  const axisLabelFormat = defaultLabelFormatX;

  // y 轴 label 默认格式化函数
  const defaultLabelFormaty = (value: number) => {
    if (isRetention) {
      if (value > 0 && value < 0.1 && String(value).length > 4) return formatPercentNum(+value, 1);
      return formatPercentNum(value, 0);
    }

    const formatLabel = value ? unitConversion(value, true) : value;
    const num = value < 1 && value > 0 ? parseFloat(value.toFixed(3)) : formatLabel;
    return num;
  };
  const yaxisLabelFormat = defaultLabelFormaty;

  // 默认柱形图和折线图的自定义配置
  const chartConfigFunc = (option: { series: string | any[]; yAxis: { axisLabel: { formatter: (value: any) => any; }; }; color: string[]; xAxis: any[]; legend: { formatter: (value: any) => string; }; }, userChartConfigFunc?: ((arg0: any) => any) | undefined) => {
    const opt = option || {};
    if (!opt.series?.length) return;
    opt.yAxis.axisLabel.formatter = yaxisLabelFormat;
    opt.color = ['#5287f4', '#8eb9ff'];
    // 格式化横坐标 label
    opt.xAxis = opt.xAxis?.map((item: { axisLabel: any; }) => ({
      ...item,
      axisLabel: {
        ...item.axisLabel,
        formatter: axisLabelFormat
      }
    }));

    opt.series[0].z = 1;
    opt.series[1]!.z = 0;
    opt.series[1].lineStyle = {
      type: 'dotted'
    };
    opt.legend.formatter = (value: string | any[]) => {
      const nametxt = value.slice(0, value.length - 11);
      const timetxt = value.slice(value.length - 10);
      const newName = (() => {
        if (['Total', 'Global'].includes(nametxt)) return formatMessage({ id: `realtime_analysis_${nametxt}` });
        return getSelectorText('country', nametxt);
      })();
      return `${newName} ${timetxt}`;
    };


    const count = lineOptions?.xAxisData.length;
    const defaultInterval = parseInt(((count - 1) / splitNum).toString());
    let differNum = count - defaultInterval * splitNum - 1;
    let preIndex = 0;
    const intervalFormat = (index: number) => {
      if (index === count - 1) {
        // 遍历完数据重置（防止数据被刷掉）
        differNum = count - defaultInterval * splitNum - 1;
        preIndex = 0;
        return true;
      }
      if (index === 0) {
        return true;
      }

      // 间隔数
      const currentInterval = differNum > 0 ? defaultInterval : defaultInterval - 1;
      if (preIndex + 1 + currentInterval === index) {
        differNum = differNum > 0 ? differNum - 1 : 0;
        preIndex = index;
        return true;
      }

      return false;
    };

    if (!isChange) {
      opt.xAxis[0].axisLabel.interval = intervalFormat;
      // opt.xAxis[0].axisLabel.hideOverlap  = true // 隐藏重叠标签
      opt.xAxis[0].axisTick.interval = intervalFormat;
    }

    return {
      ...opt,
      ...(userChartConfigFunc?.(opt) || {})
    };
  };

  // 浮层
  const lineFormatterFunc = (param: any[]) => {
    const splitData: any[] = [];
    param.forEach((item: { value?: any; name?: any; seriesName?: any; }, index: any) => {
      const { name } = item;
      const data = [{
        name: ['Total', 'Global'].includes(selectList[0]) ? formatMessage({ id: `realtime_analysis_${selectList[0]}` }) : getSelectorText('country', selectList[0]),
        metricsNum: formatterValue(item?.value),
      }];
      splitData.push({
        title: `${index ? preTime : nowTime} ${name.slice(0, 5)}`,
        metricsName: header2,
        data,
      });
    });

    return getEchartTooltipText({
      isSplit: true,
      splitData,
      isColorDepth: true,
      isShowTotal: true,
    });
  };
  // 图例处理函数
  const legndsFun = (legendData: any[][], getSelectorText: { (regionDataType: string, key: string): any; (arg0: string, arg1?: any): any; }, formatMessage: { (descriptor: MessageDescriptor, values?: Record<string, PrimitiveType>): string; (descriptor: MessageDescriptor, values?: Record<string, PrimitiveType | React.ReactElement | FormatXMLElementFn>): string | React.ReactNodeArray; (arg0: { id: string; }): any; }) => {
    const newLegends = [
      {
        type: 'scroll',
        selectedMode: true,
        orient: 'horizontal',
        itemHeight: 8,
        itemWidth: 8,
        data: legendData[0].map((item: { name: any; }, index: any) => ({
          name: item.name,
          id: index,
          icon: 'circle',
          // textStyle: {
          //   color: item.color,
          // },
        })),
        formatter: (value: string) => {
          const nameText = (() => {
            if (['Total', 'Global'].includes(value?.trim())) {
              return formatMessage({ id: `realtime_analysis_${value?.trim()}` });
            }
            return getSelectorText('country', value?.trim());
          })();
          return nameText;
        },
        bottom: '7%',
        left: '15%',
        padding: [10, 10, 0, 0],
        itemGap: 18,
        pageIconColor: '#444444', // 翻页下一页的三角按钮颜色
        pageIconInactiveColor: '#888888', // 翻页（即翻页到头时）
        pageIconSize: 12, // 翻页按钮大小
        pageButtonPosition: 'end',// start
        width: '80%',
      },
      {
        type: 'scroll',
        selectedMode: true,
        orient: 'horizontal',
        itemHeight: 8,
        itemWidth: 8,
        data: legendData[1].map((item: { name: any; }, index: any) => ({
          name: item.name,
          id: index,
          icon: 'circle',
          // textStyle: {
          //   color: item.color,
          // },
        })),
        formatter: (value: string) => {
          const nameText = (() => {
            if (['Total', 'Global'].includes(value?.trim())) {
              return formatMessage({ id: `realtime_analysis_${value?.trim()}` });
            }
            return getSelectorText('country', value?.trim());
          })();
          return nameText;
        },
        bottom: '1%',
        left: '15%',
        padding: [10, 10, 0, 0],
        itemGap: 18,
        pageIconColor: '#444444', // 翻页下一页的三角按钮颜色
        pageIconInactiveColor: '#888888', // 翻页（即翻页到头时）
        pageIconSize: 12, // 翻页按钮大小
        pageButtonPosition: 'end',// start
        width: '80%',
      }
    ];
    return newLegends;
  };
  // 多个国家对比的tooltip浮窗
  const multipleFormatterFunc = (param: any[]) => {
    const splitIndex = param.length / 2 - 1;
    const splitData: any[] = [];
    const cData: any[] = [];
    const pData: any[] = [];

    param.forEach((item: { value?: any; color?: any; seriesName?: any; }, index: number) => {
      const { seriesName } = item;
      const nameText = (() => {
        if (['Total', 'Global'].includes(seriesName?.trim())) {
          return formatMessage({ id: `realtime_analysis_${seriesName?.trim()}` });
        }
        return getSelectorText('country', seriesName?.trim());
      })();
      if (index <= splitIndex) {
        cData.push({
          name: nameText,
          metricsNum: formatterValue(item?.value),
          color: item.color,
        });
      } else {
        pData.push({
          name: nameText,
          metricsNum: formatterValue(item?.value),
          color: item.color,
        });
      }
    });
    splitData.push({
      title: `${nowTime} ${param[0]?.name.slice(0, 5)}`,
      metricsName: header2,
      z: 2,
      data: cData
    });
    splitData.push({
      title: `${preTime} ${param[0]?.name.slice(0, 5)}`,
      metricsName: header2,
      z: 4,
      data: pData
    });

    return getEchartTooltipText({
      isSplit: true,
      splitData,
      isColorDepth: true,
      isRetention,
      isShowTotal: true,
    });
  };

  const newSeries = (series: any) => {
    const cSeries: any[] = [];
    const pSeries: any[] = [];
    series.forEach((item: { color: string; }, index: number) => {
      if (index % 2) {
        item.color = LIGHT_COLORS[(index - 1) / 2];
        pSeries.push(item);
      } else {
        item.color = DEEP_COLORS[index / 2];
        cSeries.push(item);
      }
    });
    return cSeries.concat(pSeries);
  };

  const newLegend = (legendData: any) => {
    const cLegList: any[] = [];
    const pLegList: any[] = [];
    legendData.forEach((item: any, index: number) => {
      if (index % 2) {
        pLegList.push({ name: item, color: LIGHT_COLORS[(index + 1) / 2] });
      } else {
        cLegList.push({ name: item, color: DEEP_COLORS[index / 2] });
      }
    });
    const legends = [cLegList, pLegList];
    const legendResult = legndsFun(legends, getSelectorText, formatMessage);
    return legendResult;
  };

  const tabsTrend = [
    {
      id: 'chart1',
      label: <SvgIcon type="chart-line" className="svgicon" />,
      component: selectList?.length > 1 ?
        <LineChart
          height={390}
          series={newSeries(lineOptions?.series ?? [])}
          legendData={newLegend(lineOptions?.legend ?? [])}
          xAxisData={lineOptions?.xAxisData ?? []}
          formatterFunc={multipleFormatterFunc}
          nowTime={nowTime}
          preTime={preTime}
          isMultipleCompetitor={true}
          splitNum={splitNum}
          setOtherConfigFunc={(opt: { grid: { left: number; right: number; bottom: number; top: number; containLabel: boolean; }; yAxis: { axisLabel: { formatter: (value: any) => string | number; }; }; }) => {
            opt = xAxisHighLight(opt, {
              formatter: (params: { value: string | any[]; }) => params.value ? params.value?.slice(0, 5) : '',
              isRealtime: true
            });
            opt = xAxisLableFormat(opt, {
              formatter: (value: string | any[]) => value ? value?.slice(0, 5) : ''
            });
            opt.grid = {
              left: 10,
              right: 12,
              bottom: 56,
              top: 20,
              containLabel: true
            };
            if (isRetention) {
              opt.yAxis.axisLabel.formatter = (value: number) => yAxisFormat(value, true, 2, true);
            }
            return opt;
          }}
        /> :
        selectList?.length > 0 ?
          <LineChart
            height={390}
            legendData={lineOptions?.legend ?? []}
            xAxisData={lineOptions?.xAxisData ?? []}
            series={lineOptions?.series ?? []}
            formatterFunc={lineFormatterFunc}
            setOtherConfigFunc={(option: { grid: { right: number; }; }) => {
              let opt = option || {};
              opt = xAxisHighLight(opt, {
                formatter: (params: { value: string | any[]; }) => params.value ? params.value?.slice(0, 5) : '',
                isRealtime: true
              });
              opt.grid.right = 12;
              opt = chartConfigFunc(opt);
              return opt;
            }}
          /> :
          <div style={{ height: 381 }}> <NoData /></div>,
    },
    {
      id: 'chart2',
      label: <SvgIcon type="chart-table" className="svgicon" />,
      component: (
        selectList?.length > 0 ?
          <MiniTable
            height={388}
            loading={loading}
            tableOption={tableOptions?.option}
            tableConfig={{ isSortable: true, columns: ['time'], defaultValue: [{ by: 'time', order: 'desc' }] }}
            tableList={tableOptions?.data}
            scrolLableVal={tableOptions?.scrolLableVal}
          /> :
          <div style={{ height: 381 }}> <NoData /></div>
      ),
    },
  ];
  const reTimeFun = (strTime: moment.MomentInput) => {
    if (key2 === 'd2') return moment(strTime).subtract(1, 'day').format('YYYY-MM-DD');
    if (key2 === 'd3') return moment(strTime).subtract(2, 'day').format('YYYY-MM-DD');
    if (key2 === 'd7') return moment(strTime).subtract(6, 'day').format('YYYY-MM-DD');
  };
  return (
    <Card
      bordered
      className='margin-t-20 table-line'
    >
      <Card.Body
        title={
          <>
            <div className='table-title'>{title}</div>
            {cardTime && isRetention && <Text className='table-line-time'>{formatMessage({ id: 'realtime_analysis_Register_Date' })}: {reTimeFun(lastTime?.slice(0, 10))}</Text>}
            {cardTime && <Text className='table-line-time'>{formatMessage({ id: 'realtime_analysis_Statistical_Time' })}: {cardTime?.split(" ")[1]}</Text>}
          </>
        }
        operation={
          loading || isError || tableData?.length === 0 ? <></> :
            <>
              {iconList.map((t) => (
                <Bubble
                  dark
                  placement="top"
                  content={t === 'discount-chart' ? 'Line Chart' : 'Table'}
                  key={t}>
                  <Text className='table-btn table-line-show' onClick={() => { setIsLine(t) }} >
                    <SvgIcon className={isLine !== t ? 'table-icon' : 'action-icon'} type={t} />
                  </Text>
                </Bubble>
              ))}
              <Text className='table-btn' onClick={() => { openDownloadSetting() }}>
                <SvgIcon className="table-icon" type="download" />
              </Text>
            </>
        }
      >
        {
          loading ? <div style={{ height: 381 }}><Loading /></div> :
            isError ? <div style={{ height: 381 }}><LoadingFailed failedMsg={formatMessage({ id: 'common_loading_failed_realtime' })} /></div> :
              tableData?.length === 0 ? <div style={{ height: 381 }}> <NoData /></div> :
                <div className='flex-context'>
                  <Row>
                    <Col span={12}>
                      <TopTable
                        key={title + shouldAnalysisRefresh}
                        ref={topTableRef}
                        time={time}
                        lastTime={lastTime}
                        changeSelect={(value: React.SetStateAction<string[]>) => setSelectList(value)}
                        records={tableData}
                        header2={header2}
                        key2={key2}
                        isKeyCounTry={isKeyCounTry}
                        gameCode={gameCode}
                        isRetention={isRetention}
                        formatter={formatter}
                        topTableFormatter={topTableFormatter}
                      />
                    </Col>
                    <Col span={12} key={title + getLocale()}>
                      {
                        isLine === iconList[0] ?
                          <Row>
                            <Col>
                              {tabsTrend[0].component}
                            </Col>
                          </Row> :
                          <Row>
                            <Col>
                              {tabsTrend[1].component}
                            </Col>
                          </Row>
                      }
                    </Col>
                  </Row>
                </div>
        }
      </Card.Body>
    </Card>
  );
}
